<div class="invalid-phonenumber-warning-container" [ngClass]="class">
  <p>
    <strong>The number you provided is invalid.</strong> <br />If you are sure
    this is a valid and working number, you can override this message by
    <span class="phone-number-warning-action" (click)="ToggleMsg()"
      >clicking here</span
    >.
  </p>
</div>
